<template>
  <div class="box gray-box gray-box-bg">
    <div class="box-body inner-title">
      <el-row class="box-header">
        <el-col :span="18">
          <h3 v-if="!useRate">订单总计</h3>
          <h3 v-if="useRate">任务总计</h3>
        </el-col>
        <el-col :span="6" class="text-right">
          <el-button type="text" v-if="copyGoodsList.length" :disabled="!copyGoodsList.length && !currentBusiness" @click="dialogFormVisible = true">修改</el-button>
        </el-col>
      </el-row>
      <el-select @change="selectBusiness" v-if="groupList" v-model="currentBusiness" placeholder="选择商家" style="width: 100%;margin-bottom: 10px;">
        <el-option
          v-for="(item, key) in groupList"
          :key="key"
          :label="key"
          :value="key">
        </el-option>
      </el-select>
      <div class="content">
        <div v-if="!groupList && !copyGoodsList.length">
          <el-row class="empty-tip">
            <el-col :span="24">
              购物车内还没有添加商品……
            </el-col>
          </el-row>
        </div>
        <div v-if="groupList && !currentBusiness">
          <el-row class="empty-tip">
            <el-col :span="24">
              您还没有选择商家。
            </el-col>
          </el-row>
        </div>
        <div v-if="copyGoodsList.length">
          <el-row class="total-line">
            <el-col :span="12">
              商品金额
            </el-col>
            <el-col :span="12" class="text-right">
              {{amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              消费税
            </el-col>
            <el-col :span="12" class="text-right">
              {{tax_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              商家运费
            </el-col>
            <el-col :span="12" class="text-right">
              {{transport_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line">
            <el-col :span="12">
              其他费用
            </el-col>
            <el-col :span="12" class="text-right">
              {{other_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line" v-if="useRate && taskInfo.support_transport_service === '2'">
            <el-col :span="12">
              <span >国际运费</span>
            </el-col>
            <el-col :span="12" class="text-right">
              ¥{{ taskInfo.conditions.package_forwarding_fee }}
            </el-col>
          </el-row>
          <el-row class="total-line" v-if="useRate">
            <el-col :span="12">
              <span>服务费</span>
            </el-col>
            <el-col :span="12" class="text-right">
              {{service_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-line" v-if="useRate">
            <el-col :span="12">
              <span>实时汇率</span>
            </el-col>
            <el-col :span="12" class="text-right">
              {{currency_rate}}{{taskInfo.currency}}/CNY
            </el-col>
          </el-row>
          <el-row class="total-line" v-if="useRate">
            <el-col :span="12">
              <span >任务总计</span>
            </el-col>
            <el-col :span="12" class="text-right">
              {{$decimalFormat(total_amount,2) | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
          <el-row class="total-sum">
            <el-col :span="12">
              <span v-if="!useRate">订单金额</span>
              <span v-if="useRate">任务金额</span>
            </el-col>
            <el-col v-if="!useRate" :span="12" class="text-right amount">
              {{total_amount | currency(taskInfo.currency_symbol)}}
            </el-col>
            <el-col v-if="useRate" :span="12" class="text-right amount">
              {{total_rate_amount | currency('¥')}}
            </el-col>
          </el-row>
        </div>
        <el-button :disabled="Number(total_rate_amount) <= 0" v-if="useRate" class="block" type="info" @click="taskInfoSubmit()">确定</el-button>
        <el-button :disabled="!copyGoodsList.length || !currentBusiness" v-if="!useRate" class="block" type="info" @click="next()" :loading="loading">确定</el-button>
      </div>
    </div>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <h3 class="text-center">修改金额</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="(error,index) in errors" :key="index">{{error[0].message}}</li>
        </ul>
        <el-form-item label="" prop="tax_amount">
          <YueDanIpt :reg="/^\d+\.?\d{0,2}$/" model="tax_amount" :object="form" placeholder="消费税" :append="taskInfo.currency"></YueDanIpt>
        </el-form-item>
        <el-form-item label="" prop="transport_amount">
          <YueDanIpt :reg="/^\d+\.?\d{0,2}$/" model="transport_amount" :object="form" placeholder="商家运费" :append="taskInfo.currency"></YueDanIpt>
        </el-form-item>
        <el-form-item label="" prop="other_amount">
          <YueDanIpt :reg="/^\d*\.?\d{0,2}$/" model="other_amount" :object="form" placeholder="其他费用" :append="taskInfo.currency"></YueDanIpt>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="block" type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="paymentDialogVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="paymentDialogVisible" width="90%">
      <PaymentTip v-on:close="closeOtherPaymentDialogVisible" :newWindow="newWindow" :orderId="orderId" :order="taskInfo" :orderNo="order_no" :type="taskInfo.payment_type_info.type"></PaymentTip>
    </el-dialog>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import {API_HOST} from '../../../services/constant.js'
import PaymentTip from '../../payment/PaymentTip'
let _ = require('lodash')

export default {
  name: 'OrderTotal',
  props: ['goodsList', 'useRate', 'groupList'],
  components: {
    YueDanIpt: YueDanIpt,
    PaymentTip: PaymentTip
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  data () {
    var checkIsPrice = (rule, value, callback) => {
      if (value && (isNaN(value) || value < 0)) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }

    return {
      // exchangeRates: [],
      isSubmit: false,
      newWindow: null,
      checkPaidStatusInterval: null,
      orderId: null,
      wechatDialogVisible: false,
      paymentDialogVisible: false,
      businesses: [],
      total_rate_amount: null,
      loading: false,
      dialogFormVisible: false,
      errors: null,
      isEmptyErrors: true,
      copyGoodsList: [],
      form: {
        tax_amount: 0,
        transport_amount: 0,
        other_amount: 0
      },
      // business: null,
      bussinessList: null,
      tax_amount: 0,
      transport_amount: 0,
      other_amount: 0,
      service_amount: 0,
      currency_rate: 0,
      amount: 0,
      total_amount: 0,
      currentBusiness: null,
      rules: {
        tax_amount: [
          { required: true, message: '消费税是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        transport_amount: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        other_amount: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ]
      },
      isSingle: false,
      order_no: null,
      isInit:true,
    }
  },
  watch: {
    amount: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          //如果是初次进入，不进行计算，而是把taskinfo的税费赋值给其他
          if(!this.isInit){
            if (this.taskInfo.business && this.taskInfo.business.merchant_tag === 'LululemonCA') {
              this.tax_amount = this.$decimalFormat(val * 0.05,2)
              this.form.tax_amount = this.$decimalFormat(val * 0.05,2)
              this.taskInfo.tax_amount = this.$decimalFormat(this.amount * 0.05,2)
            } else {
              this.tax_amount = 0
              this.form.tax_amount = 0
            }
            console.log("notinit");
          }
          else{
            this.tax_amount=this.taskInfo.tax_amount;
            this.form.tax_amount=this.taskInfo.tax_amount;
            this.isInit=false;
            console.log("init");
          }
          
        }
      }
    },
    goodsList: {
      handler: function (val, oldVal) {
        this.copyGoodsList = this.goodsList || []
        this.currentBusiness = this.$route.query.business_name || this.taskInfo.business_name
        this.cal()
        console.log("goodsList");
      },
      deep: true
    },
    copyGoodsList: {
      handler: function (val, oldVal) {
        this.cal()
        console.log("copyGoodsList");
      },
      deep: true
    },
    groupList: {
      handler: function (val) {
        this.selectBusiness(this.currentBusiness)
        this.cal()
        console.log("groupList");
      },
      deep: true
    },
    taskInfo: {
      handler: function (val) {
        this.cal()
        console.log("taskInfo");
      },
      deep: true
    }
  },
  async created () {
    api.getExchangeRates(this).then(res => {
      this.exchangeRates = res.body.result
      this.currentBusiness = this.$route.query.business_name || this.taskInfo.business_name
      this.isSingle = this.$route.fullPath.indexOf('buyer') > -1
      this.init()
      this.cal()
    })
  },
  methods: {
    updateTaskInfoCurrency (business) {
      _.each(this.exchangeRates, item => {
        if (business.currency == item.currency) {
          Object.assign(this.taskInfo, { currencyInfo: item })
          this.taskInfo.business = business
          this.$store.commit('updateTaskInfo', this.taskInfo)
        }
      })
    },
    async selectBusiness (key) {
      if (!key) return
      this.copyGoodsList = []
      if (this.groupList) {
        let list = this.groupList[key] || []
        this.copyGoodsList = list.map(item => {
          item.cart_id = item.id
          return item
        })
        this.updateTaskInfoCurrency(list[0])
        this.$router.push({ path: '/publish_task/cart',
          query: {
            business_name: key
          }}).catch(err=>{err})
        this.$forceUpdate()
      }
    },
    async initEditOrder () {
      let orderId = this.$route.query.order_id
      if (orderId && !this.taskInfo.id) {
        let res = await api.getOrderById(this, {
          order_id: orderId
        })
        res = res.body.result
        res.address_info = res.address
        res.conditions = JSON.parse(res.conditions)
        res.coupon = JSON.parse(res.coupon)
        await this.getGroupBussinessList(res)
        _.each(res.goods_list, goods => {
          goods.business_name = res.business_name
          goods.business_id = res.business_id
          goods.business_website = res.business_website
        })
        Object.assign(this.taskInfo, res)
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
    },
    async getGroupBussinessList (data) {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
      if (this.bussinessList[data.business_id]) {
        data.business_name = this.bussinessList[data.business_id][0].name
        data.business_website = this.bussinessList[data.business_id][0].website
      }
    },
    closeOtherPaymentDialogVisible: function () {
      this.paymentDialogVisible = false
    },
    cal () {
      if (!this.currentBusiness) return
      this.amount = 0
      _.each(this.copyGoodsList, goods => {
        this.amount = ((Number(this.amount)) * 1000 + (Number(goods.discounted_price) * goods.number) * 1000) / 1000
      })
      if (this.taskInfo.service) {
        const serviceInfo = this.taskInfo.service
        this.service_amount = this.$decimalFormat((Number(serviceInfo.service_price)),2)
        if (this.useRate) {
          let t=(parseFloat(this.amount) + parseFloat(this.tax_amount) + parseFloat(this.service_amount) + parseFloat(this.transport_amount))
          this.total_amount = this.$decimalFormat(t,2)
        } else {
          let t2=(parseFloat(this.amount) + parseFloat(this.tax_amount) + parseFloat(this.transport_amount))
          this.total_amount = this.$decimalFormat(t2,2)
        }
      } else {
        this.total_amount = 0
        this.copyGoodsList.forEach(item => {
          this.total_amount += Number(item.discounted_price || item.price)*Number(item.number)
        })
        // 总计应包含消费税、商家运费、其他费用
        this.total_amount = this.total_amount + parseFloat(this.tax_amount) + parseFloat(this.transport_amount) + parseFloat(this.other_amount)
      }
      if (this.useRate) {
        this.total_amount = ((this.total_amount) * 1000 + (Number(this.other_amount)) * 1000) / 1000
        this.total_rate_amount = this.total_amount * parseFloat(this.taskInfo.currency_rate) + Number(this.taskInfo.conditions.package_forwarding_fee)
      }
      this.currency_rate = this.taskInfo.currency_rate
      this.taskInfo.service_amount = this.service_amount
      this.taskInfo.total_amount = this.total_amount
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    init () {
      this.errors = null
      this.isEmptyErrors = true
      this.form = {
        tax_amount: this.taskInfo.tax_amount || 0,
        transport_amount: this.taskInfo.transport_amount || 0,
        other_amount: this.taskInfo.other_amount || 0
      }
      this.tax_amount = this.taskInfo.tax_amount || 0
      this.transport_amount = this.taskInfo.transport_amount || 0
      this.other_amount = this.taskInfo.other_amount || 0
      console.log(112, this.tax_amount)
      if (this.goodsList.length) {
        this.copyGoodsList = this.goodsList
      } else if (this.copyGoodsList.length) {
        this.copyGoodsList = this.copyGoodsList
      } else {
        this.copyGoodsList = []
      }
      this.checkPaidStatus()
      this.checkPaidStatusInterval = setInterval(() => {
        this.checkPaidStatus()
      }, 2000)
    },
    submit () {
      this.tax_amount = this.form.tax_amount
      this.transport_amount = this.form.transport_amount
      this.other_amount = this.form.other_amount
      this.$refs['form'].validate((valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          this.taskInfo.transport_amount_charge_type=this.taskInfo.conditions.transport_amount_charge_type;
          this.taskInfo.package_forwarding_fee=this.taskInfo.conditions.package_forwarding_fee;
          this.taskInfo.tax_amount = this.tax_amount
          this.taskInfo.transport_amount = this.transport_amount
          this.taskInfo.other_amount = this.other_amount
          this.cal()
          this.$store.commit('updateTaskInfo', this.taskInfo)
          console.log("taskinfo",this.$store.state.taskInfo)
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    async taskInfoSubmit () {
      if (this.isSubmit) {
        return
      }
      this.isSubmit = true
      let apiType = this.isSingle ? '_by_single' : '_by_buyer'
      if (this.taskInfo.id) {
        this.taskInfo.order_id = this.taskInfo.id
        apiType = 'update' + apiType
      } else {
        apiType = 'add' + apiType
      }
      if (this.taskInfo.payment_type_info.type != 2 && !this.isSingle) {
        this.newWindow = window
      }
      this.taskInfo.transport_amount_charge_type=this.taskInfo.conditions.transport_amount_charge_type;
      this.taskInfo.package_forwarding_fee=this.taskInfo.conditions.package_forwarding_fee;
      let res = await api.post(this, {
        path: 'order.php',
        data: this.taskInfo,
        loading: 'loading',
        api: apiType
      })

      if (this.taskInfo.id) {
        this.$store.commit('clearTaskInfo')
        this.$router.push({path: this.$localStorage.get('goBackOrderUrl')})
        return
      }

      if (this.isSingle) {
        this.$store.commit('clearTaskInfo')
        this.$localStorage.remove('addressName')
        this.$router.push({ path: '/Complete', query: {isSingle: this.isSingle, order_no: res.body.result.order_no}})
      } else {
        let id = res.body.result
        if (id) {
          this.isSubmit = false
          if (this.taskInfo.payment_type_id == 0 || this.taskInfo.payment_type_info.type == 20) {
            this.$router.push({ path: '/Complete', query: {isSingle: this.isSingle, order_no: id.order_no}})
            this.$store.commit('clearTaskInfo')
            return
          }
          this.$router.push({ path: '/publish_task/confirm', query: {pay_order_id: id.id}})
          this.orderId = id.id
          this.paymentDialogVisible = true
          this.order_no = id.order_no
        }
      }
    },
    async next () {
      if (!this.copyGoodsList || !this.copyGoodsList.length) {
        this.$message.error('请添加商品')
        return false
      }
      let path
      // if (!this.taskInfo.id) {
      //   path = 'address'
      // }
      this.taskInfo.amount = this.amount
      this.taskInfo.total_amount = this.total_amount
      if (this.taskInfo.editConfirmProduct || this.$route.query.order_id) {
        path = 'confirm'
        delete this.taskInfo.editConfirmProduct
      } else {
        path = 'address'
      }
      this.taskInfo.business_id = this.taskInfo.business.business_id
      this.taskInfo.business_name = this.taskInfo.business.business_name
      this.taskInfo.business_website = this.taskInfo.business.business_website
      this.taskInfo.goods_list = this.copyGoodsList
      this.taskInfo.fee_adjustment_list = []
      this.$store.commit('updateTaskInfo', this.taskInfo)
      this.$router.push({ path, query: this.$route.query}) // 第一步跳转应到address
    },
    async getLatestAddress () {
      let res = await api.getLatestAddress(this)
      let result = res.body.result
      if (result) {
        this.taskInfo.address_info = result
        this.taskInfo.address_id = result.id
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
      return result
    },
    async checkPaidStatus () {
      let pay_order_id = this.$route.query.pay_order_id
      if (!pay_order_id) {
        return
      }
      try {
        let { body } = await api.checkPaidStatus(this, {
          order_id: pay_order_id,
          login_dialog: true
        })
        this.payState = body.result || 0

        if (this.payState != 0) {
          clearInterval(this.checkPaidStatusInterval)
          if (this.$route.path == '/customer/task/list') {
            this.$store.commit('clearTaskInfo')
            this.$router.go(0)
          } else {
            this.$store.commit('clearTaskInfo')
            this.$router.push({ path: '/Complete', query: {order_id: pay_order_id} })
          }
        }
      } catch (e) {

      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.total-line {
  color: #686B73;
  line-height: 22px;
}
.total-sum {
  padding: 10px 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #DEE2EC;

  .amount {
    font-size: 24px;
    line-height: 33px;
  }
}

.empty-tip {
  color: #686B73;
  padding: 10px 0 25px;
  margin-bottom: 20px;
  border-bottom: 2px solid #DEE2EC;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/OrderTotal.vue